import React from 'react';
import { Tag } from '@duxton-web/ui';
import { CloseCircleFilled, StopUniversal, TickMarkFilled } from '@duxton-web/icons';

export const RF_STATUS_RENDER: Record<string, () => JSX.Element> = {
  PASSED_RF: () => <Tag color="green" icon={<TickMarkFilled />}>Pass</Tag>,
  FAILED_RF: () => <Tag color="red" icon={<CloseCircleFilled />}>Fail</Tag>,
};

export const XCO_STATUS_RENDER: Record<string, () => JSX.Element> = {
  DROPPED_FREQ_CAP: () => <Tag color="red" icon={<StopUniversal />}>XCO Freq Cap</Tag>,
  SELECTED_FOR_DISPATCH: () => <Tag color="green" icon={<TickMarkFilled />}>Dispatched</Tag>,
};

export const getCampaignUrl = (
  trackingID: string | null,
  fallbackCampaignId: string,
): string => {
  const baseUrl = window.location.origin;

  if (!trackingID || trackingID.startsWith('ts_')) {
    return `${baseUrl}/ucd/campaign/${fallbackCampaignId}`;
  }

  const [projectId, campaignId] = trackingID.split('_');
  if (!projectId || !campaignId) {
    return `${baseUrl}/ucd/campaign/${fallbackCampaignId}`;
  }

  return `${baseUrl}/ucd/project/${projectId}/campaign/${campaignId}/smart-comms/view?previousPageIsListing=true`;
};
